import { render, staticRenderFns } from "./ship_to_table.vue?vue&type=template&id=15226fe3&"
import script from "./ship_to_table.vue?vue&type=script&lang=js&"
export * from "./ship_to_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports